import * as React from 'react';
import { ModalWindow, UIText1, useDeviceType } from '@cian/ui-kit';

export interface IRequestFormModalWindowProps {
  content: React.ReactElement;
  footer: React.ReactElement;
  onClose: () => void;
  open: boolean;
}

export const RequestFormModalWindow: React.FC<IRequestFormModalWindowProps> = ({ content, footer, onClose, open }) => {
  const deviceType = useDeviceType();

  const isPhone = deviceType === 'phone';
  const height = isPhone ? '100%' : undefined;

  const header = isPhone ? null : (
    <UIText1>
      Консультант изучит ваши пожелания и перезвонит в течение суток c&nbsp;индивидуальными предложениями
    </UIText1>
  );

  return (
    <ModalWindow
      content={content}
      escape
      fixed={!isPhone}
      footer={footer}
      header={header}
      height={height}
      onClose={onClose}
      open={open}
      outside
      print
      size="M"
      title="Расскажите, что вы ищете"
      width={688}
    />
  );
};
